import { useEffect, useState } from "react";
import { Box, Button, Flex, HStack, Text, Link } from "@chakra-ui/react";
import { ACCENT, ACCENT_HOVER } from "../theme/tokens";

export const COOKIE_CONSENT_KEY = "gwbi_cookie_consent";
export const COOKIE_CONSENT_EVENT = "gwbi:cookie-consent";

export function getCookieConsent() {
  try {
    return localStorage.getItem(COOKIE_CONSENT_KEY) || null;
  } catch {
    return null;
  }
}

// Bottom banner shown until the visitor chooses. "all" enables analytics;
// "essential" keeps only strictly-necessary cookies.
export default function CookieConsent() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!getCookieConsent()) setShow(true);
  }, []);

  const choose = (value) => {
    try {
      localStorage.setItem(COOKIE_CONSENT_KEY, value);
    } catch {
      /* ignore */
    }
    try {
      window.dispatchEvent(new CustomEvent(COOKIE_CONSENT_EVENT, { detail: value }));
    } catch {
      /* ignore */
    }
    setShow(false);
  };

  if (!show) return null;

  return (
    <Box
      position="fixed"
      bottom={{ base: 3, md: 4 }}
      left={{ base: 3, md: 4 }}
      right={{ base: 3, md: 4 }}
      mx="auto"
      maxW="3xl"
      zIndex={6000}
      bg="surface.card"
      borderWidth="1px"
      borderColor="border.default"
      borderRadius="ui-lg"
      boxShadow="ui-md"
      p={4}
    >
      <Flex direction={{ base: "column", md: "row" }} align={{ md: "center" }} gap={3}>
        <Text fontSize="sm" color="gray.700" flex="1">
          We use essential cookies to run the site and, with your consent, analytics to understand
          how it’s used. See our{" "}
          <Link href="/privacy" isExternal color={ACCENT} fontWeight="600">
            Privacy Policy
          </Link>
          .
        </Text>
        <HStack spacing={2} flexShrink={0} justify={{ base: "stretch", md: "flex-end" }}>
          <Button size="sm" variant="ghost" onClick={() => choose("essential")}>
            Essential only
          </Button>
          <Button size="sm" bg={ACCENT} color="white" _hover={{ bg: ACCENT_HOVER }} onClick={() => choose("all")}>
            Accept all
          </Button>
        </HStack>
      </Flex>
    </Box>
  );
}
